import { motion } from "framer-motion";
import { ArrowLeft, ArrowUpRight } from "lucide-react";
import { articles } from "@/data/blog";
import Seo from "@/components/Seo";

const EASE = [0.22, 1, 0.36, 1];

export default function BlogArticle({ t, lang, slug }) {
    const article = articles.find((a) => a.slug === slug);
    if (!article) {
        return (
            <main className="relative z-10 mx-auto max-w-3xl px-5 sm:px-8 pt-36 pb-24 min-h-screen">
                <Seo title={t.blog.metaTitleList} description={t.blog.metaDescription} />
                <p className="text-fog">404</p>
                <a href="/blog" data-testid="blog-back-link" className="mt-4 inline-flex items-center gap-2 text-glacier">
                    <ArrowLeft size={14} /> {t.blog.back}
                </a>
            </main>
        );
    }
    const c = article[lang] || article.sk;
    return (
        <main className="relative z-10 mx-auto max-w-3xl px-5 sm:px-8 pt-36 pb-24 min-h-screen">
            <Seo title={`${c.title} — Webryno Studio`} description={c.excerpt} />
            <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: EASE }}>
                <a
                    href="/blog"
                    data-testid="blog-back-link"
                    className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.22em] text-fog transition-colors duration-300 hover:text-glacier"
                >
                    <ArrowLeft size={14} /> {t.blog.back}
                </a>
                <p className="mt-10 font-mono text-[11px] uppercase tracking-[0.3em] text-glacier">
                    {article.date} · {article.readMinutes} {t.blog.minRead}
                </p>
                <h1 className="mt-4 font-display text-3xl sm:text-5xl font-medium leading-tight tracking-tight text-ivory">
                    {c.title}
                </h1>
                <div className="mt-12 space-y-7">
                    {c.body.map((b, i) =>
                        b.h ? (
                            <h2 key={i} className="pt-4 font-display text-2xl font-medium tracking-tight text-ivory">
                                {b.h}
                            </h2>
                        ) : (
                            <p key={i} className="text-base leading-relaxed text-fog">{b.p}</p>
                        ),
                    )}
                </div>
                <div className="mt-16 rounded-lg border border-glacier/25 bg-coal p-8">
                    <p className="font-display text-xl font-medium text-ivory">{t.blog.ctaTitle}</p>
                    <p className="mt-2 text-sm leading-relaxed text-fog">{t.blog.ctaText}</p>
                    <a
                        href="/#kontakt"
                        data-testid="blog-article-cta"
                        className="mt-6 inline-flex items-center gap-2 rounded-sm bg-glacier btn-shine px-6 py-3 font-display text-xs font-semibold uppercase tracking-widest text-ink transition-colors duration-300 hover:bg-ivory"
                    >
                        {t.blog.ctaButton} <ArrowUpRight size={14} />
                    </a>
                </div>
            </motion.div>
        </main>
    );
}
